import { IPeriods } from '@app/modules/employees';
import { PATH_DASHBOARD } from '@app/routes/paths';

// App Configs
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.app;
// ----------------------------------------------------------------------

// Api Configs
export const BASE_URL = process.env.REACT_APP_BASE_URL ?? '';
export const API_TIMEOUT = process.env.REACT_APP_API_TIMEOUT ?? 0;
export const API_PREFIX = '/api/v1';
// ----------------------------------------------------------------------

export const COMPANY_NAME = 'SyncGlob';
export const PHONE = '+91 84371-70202';
export const EMAIL = 'info@syncglob.com';
export const ADDRESS =
  'First Floor of Plot No. 63, Basant Kunj, Sri Ganganagar, 335001, Rajasthan, India';

// ----------------------------------------------------------------------

export const NAV = {
  W_DASHBOARD: 280,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
};

// ----------------------------------------------------------------------

export const TIME_SCHEDULE = {
  END_OF_THE_DAY: 18,
  START_OF_THE_DAY: 10,
  SLOT_TIME_LENGTH: 60, // 60 minutes
};

export const LEAVE_CONFIG = {
  SANDWICH_CONFIG: false,
};

export const getFileType = (fileUrl: string) => {
  const match = fileUrl.match(/\.([^.?#]+)(?:[?#]|$)/);
  if (match) {
    const extension = match[1].toLowerCase();
    if (extension === 'pdf') {
      return 'pdf';
    } else if (extension === 'doc' || extension === 'docx') {
      return 'word';
    }
  }
  return 'unknown';
};
export const getDurationDisplay = (data: number) => {
  const years = Math.floor(data / 365);
  const months = Math.floor((data % 365) / 30);
  const days = data % 30;

  let durationDisplay = '';
  if (years > 0) {
    durationDisplay += `${years} year${years !== 1 ? 's' : ''} `;
  }
  if (months > 0 && years === 0) {
    durationDisplay += `${months} month${months !== 1 ? 's' : ''} `;
  }
  if (days > 0 && months === 0) {
    durationDisplay += `${days} day${days !== 1 ? 's' : ''}`;
  }
  return durationDisplay.trim();
};

export const calculateTotalLeaves = (periods: IPeriods[]) => {
  return periods.reduce((count: number, period: IPeriods) => {
    if (!period.period || period.period === 'Full Day') {
      return count + 1;
    } else if (period.period === '1st Half' || period.period === '2nd Half') {
      return count + 0.5;
    }
    return count;
  }, 0);
};

// ---------------Sockets-------------------
export * from './sockets';
